import { css } from '@emotion/react';
import { theme } from 'global';

export const completeMfaDialog = css`
  & .MuiDialogContent-root {
    padding-top: 24px;
    padding-bottom: 24px;
    padding-left: 32px;
    padding-right: 32px;
  }

  @media screen and (max-width: ${theme.breaks.xs}px) {
    .MuiDialog-paperFullWidth {
      left: 24px;
      right: 24px;
      bottom: unset;
      border-radius: 8px;
    }
  }
`;

export const completeMfaDialogContent = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const completeMfaDialogTitle = css`
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
  margin-bottom: 10px;
`;

export const completeMfaDialogText = css`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  margin-bottom: 10px;
`;

export const completeMfaDialogButtonRegion = css`
  display: flex;
  justify-content: flex-end;

  @media screen and (max-width: ${theme.breaks.xs}px) {
    justify-content: center;
  }
`;

export const completeMfaDialogSignOutButton = css`
  width: 102px;
  height: 44px;
  @media screen and (max-width: ${theme.breaks.xs}px) {
    width: 100%;
  }
`;
export const completeMfaBanner = css`
  margin-bottom: 16px;
`;

export const completeMfaBannerText = css`
  margin: 0px;
  text-decoration: underline;
  &:hover {
    cursor: pointer;
  }
`;
